import WorkflowRules from '@/pages/workflowRulesAdmin/workflowRules/WorkflowRulesAdmin.page'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ReactFlow, ReactFlowProvider, useReactFlow } from '@xyflow/react'

export const Route = createFileRoute('/_auth/workflow-rules')({
  // component: () => <IFramePage url='workflow-rules.html' />,
  component: () => <WorkflowRulesLayout />,
})

const WorkflowRulesLayout = () => {
  return (
    <>
      <FlowWithProvider>
        <WorkflowRules />
        <Outlet />
      </FlowWithProvider>
    </>
  )
}

function Flow(props: any) {
  // you can access the internal state here
  const reactFlowInstance = useReactFlow()

  return <ReactFlow {...props} />
}

// wrapping with ReactFlowProvider is done outside of the component
function FlowWithProvider(props: any) {
  return (
    <ReactFlowProvider>
      {props.children}
      {/* <Flow {...props} /> */}
    </ReactFlowProvider>
  )
}
